// lang-en.ts

export const LANG_JP_NAME = 'jp';

export const LANG_JP_TRANS = {
  'Crm_Login_Header': 'ログイン',//私達は使用します 'ログイン' の代わりに 'メンバーログイン'
  'Email-id': 'メールアドレス',//メールアドレス
  'Crm_Password': 'パスワード',
  'Crm_Validation_WrongEmailPwd': '無効のメールアドレスまたはパスワード',//それ以外の 間違ったメールID / パスワード.
  'I_have_read_and_agree_to_the': '私は読んで同意しました',
  'Login_Please_Enter_Email_and_Password': 'メールアドレスとパスワードを入力して下さい',
  'By_Logging_in_you_agree_to_our': 'ログインすることであなたはこれに同意することになります',
  'Privacy_Policy': 'プライバシーポリシー',
  'Crm_MT4_Submit': '実行',
  'Forgot_Password': 'パスワードを忘れた',
  'Verification_Link_Sent': '承認リンクを送信しました',
  'Enter_valid_email': '有効なメールアドレスを入力してください',
  'Crm_Footer_Message': 'ウェブトレーダーはメタトレーダー4プラットフォームで実行される取引指示を中継するインターフェースです。これらのインターフェースに表示されるタイミングと価格はインターネットの接続の強度と安定性に大きく依存します. 最も正確な最終結果についてはメタトレーダー４プラットフォームの取引詳細を参照してください.',
  'Please_Enter_Email': 'メールアドレスを入力してください',
  'Enter_Email': 'メールアドレスを入力してください',
  'Please_Enter_Password': 'パスワードを入力してください',
  'Please_Accept_Privacy_Policy': 'プライバシーポリシーに同意する',//プライバシーポリシーに同意するの代わりに
  'Please_enter_your_registered_email': '登録のメールアドレスを入力してください',//このメールアドレスは登録されていませんの代わりに!
  'Getting_started_with': 'はじめに',
  'web_tarder_carousel': 'ウエブトレーダー',
  'Light_up_your_phone_Trade': '携帯電話取引を活性化してください...',
  'Anytime_Anywhere_carousel': 'いつでも. どこでも',
  'The_Worlds_Most_Advanced': '世界で最も先進の',
  'MT4_FX_Derivatives': 'MT4 FX デリバティブ',
  'FX_Derivatives': 'FX デリバティブ',
  'Binding_MT4_Account': 'MT4 ログイン',
  'Binding_Account_Number': '口座番号',
  'MT4_Password': 'パスワード',
  'MT4_Remember_Me': '覚えておいてください',
  'Powered_by': '搭載 ',
  'Back_to': 'へ戻る ',
  'Back_to_Login': 'ログインへ戻る',
  'MT4_Submit': '実行',
  'Trade_Loading': '読み込み中',
  'Trade_Profile': 'プロフィール',
  'Trade_Trading_History': '取引履歴',
  'Trade_Deposit': '入金',
  'Trade_Withdrawal': '出金',
  'Trade_Settings': '設定',
  'Trade_Feedback': 'フィードバック',
  'Trade_About_us': '弊社について',
  'Trade_Logout': 'ログアウト',
  'Trade_Search': 'サーチ',
  'Trade_Favorites': 'お気に入り',
  'Trade_No_Favorites': 'お気に入りは見つかりませんでした',
  'Trade_Balance': '残高',
  'Trade_Open_Trades': '実行中取引',
  'Trade_History': '履歴',
  'Trade_Amount': '取引額',
  'Trade_Profit': '利益',
  'Trade_OK': 'OK',
  'Trade_UP': 'CALL',
  'Trade_DOWN': 'PUT',
  'Trade_Total_Exosure': '合計エクスポージャー',
  'Trade_One_Click_Trading': 'ワンクリックトレード',
  'Trade_Sounds': '音',
  'Trade_Language': '言語',
  'Trade_Chinese': '中国語',
  'Trade_Confirm_Trade': '取引確定',
  'Trade_Submit': '実行',
  'Trade_Close': '取消',
  'Hist_Full_Trade_History': '全取引履歴',
  'Hist_Showing': '見せている',
  'Page_number' : '',
  'Hist_of': 'オブ',
  'Hist_Date': '日付',
  'Hist_Symbol': '銘柄',
  'Hist_Action': 'アクション',
  'Hist_Open': 'オープン',
  'Hist_Close': '取消',
  'Hist_Amount': '取引額',
  'Hist_Profit': '利益',
  'Hist_Interval': '時間枠',
  'Hist_Result': '結果',
  'Hist_No_History': '取引履歴は見つかりませんでした',
  'Hist_Loading': '読み込み中',
  'Ind_BB': 'ボリンジャーバンド',
  'Ind_MACD': 'MACD',
  'Ind_Stochastic': '確率変数',
  'Ind_SMA': 'SMA',
  'Ind_RSI': 'RSI',
  'Ind_EMA': 'EMA',
  'Ind_SETTINGS': '設定',
  'Ind_OK': 'OK',
  'Ind_Close': '取消',
  'Open_Open_Positions': 'オープンポジション',
  'Open_NO_Trade': 'オープントレードはありません',
  'Open_Open': 'オープン',
  'Open_Close': '取消',
  'Open_Amount': '額',
  'Open_Profit': '利益',
  'Win': '勝ち',
  'Loss': '負け',
  'Draw': '引き分け',
  'BB': 'ボリンジャーバンド',
  'MACD': 'MACD',
  'STOCHASTIC': '確率変数',
  'SMA': 'SMA',
  'RSI': 'RSI',
  'EMA': 'EMA',
  'OVERSOLD': 'オーバーソルド',
  'OVERBOUGHT': 'オーバーボウト',
  'Period': '期間',
  'UNDEFINED': '未定義',
  'SIGNAL PERIOD': 'シグナルピリオド',
  'FAST PERIOD': 'ファーストピリオド',
  'SLOW PERIOD': 'スローピリオド',
  'PERIOD': '期間',
  'STANDARD DEVIATION': '標準偏差',
  'K PERIOD': 'K ピリオド',
  'D PERIOD': 'D ピリオド',
  'Trade_Double_Up': 'ダブルアップ',
  'Up': 'CALL',
  'Down': 'PUT',
  'Trade_Min_Amount': '最小金額',
  'Trade_Max_Amount': '最大金額',
  'Trade_Insufficient_Account_Balance': '口座残高不足',
  'Trade_Amount_Range_1': '金額は以下の範囲内でなければなりません',
  'Trade_Amount_Range_2': 'まで',
  'Trade_Amount_Range_3': ' ',
  'Trade_Amount_Multiples_Of': '金額は次の倍数である必要があります',
  'Trade_Amount_Multiples_Of_After': ' ',
  'Trade_Too_many_orders': '注文が多すぎます',
  'Trade_Market_is_closed': '市場は閉まっています',
  'Trade_Invalid_parameters': '無効なパラメータ',
  'Trade_Submit_order_failure': '現在注文できません',
  'Trade_Invalid_Amount': '無効な金額です',
  'Trade_Account_Inactive': 'あなたのMT4ステータスが非アクティブです。カスタマーサービスにお問い合わせください',
  'Trade_Low_Volatility': '低ボラティリティのため取引できません',
  'Trade_Off_Quotes': '低ボラティリティのため取引できません',
  'Trade_Hedging_not_allowed': 'ヘッジは無効になっています',
  'Internet_connection_is_slow': 'インターネット接続が遅い',
  'Internet_connection_is_lost_Reconnecting': 'インターネット接続が失われました。 再接続中....',
  'Connecting': '接続中....',
  'Your_session_will_expire_in_next': 'あなたのセッションは次回、期限切れになります',
  'Trade_seconds': '秒',
  'Trade_Not_enough_money': '残高不足',
  'Trade_Reached_Max_Chart_Tabs': 'チャートのタブが最大数に達しました',
  'Trade_Order_placed_successfully': '注文は正常に完了しました',
  'The_Reset_Password_Link_has_been_sent_to_your_email': 'パスワードをリセットするリンクがメールに送信されました',
  'Please_Enter_email_address:': 'メールアドレスを入力してください',
  'Trade_deposit_redirect': '入金画面に移動します',
  'Trade_withdrawal_redirect': '出金のためCRMにリダイレクトされます.',
  'Trade_Sure': 'はい',
  'Trade_not_now': 'いいえ',
  'Trade_No_Symbols_Found': 'シンボルが見つかりませんでした',
  'Log_Out_Mssg': 'ログアウトされます。続行しますか ?',
  'MT4_Password_Incorrect': 'パスワードが間違っています',
  'Max_Indicators': '1度に最大3つのインジケーターが許可されます',
  'Bookmark_Chart': 'ここでお気に入りのチャートをブックマークしてください',
  'Trade_Chart_Bookmarked': 'チャートはすでにブックマークされています',
  'MACD_Fast_Period_Greater_Than_Slow_Period': 'Fast periodはslow periodよりも短くなければなりません',
  'Bookmark_Added': 'ブックマークが追加されました',
  'Orientation_wait': 'しばらくお待ちください...',
  'Orientation_rotate_landscape': 'ユーザーエクスペリエンスを向上させるために、画面を横向きモードに回転させます.',
  'Orientation_note': '注: デバイスの自動回転が無効になっている場合は、有効にしてください.',
  'mobiledevice_line1': 'ワンストップ取引プラットフォーム',
  'mobiledevice_line2': ' アンドロイドアプリも利用可能です.',
  'mobiledevice_download_app': 'ダウンロードする',
  'Verified': '認証されました',
  'Not_Verified': '認証されていません',
  'Citizenship': '市民権',
  'Profile': 'プロフィール',
  'withdrawal_heading': '出金',
  'register': '今すぐ登録する',
  'Bankwire_Deposit_Success': '入金が正常に送信されました!!',
  'promoCodePlaceholder': 'プロモーションコード(オプション)',
  'get_email_otp': 'ワンタイムパスワードをメールで入手する',
  'check your email': 'メールを確認してください',
  'tosAgreeLabel': '私は以下を読み、理解し、承諾します',
  'termsOfServices': 'Terms Of Services',
  'email_otp_sent': 'ワンタイムパスワードがメールで送信されました',
  'countryPlaceholder': '国',
  'phoneCodePlaceholder': '電話コード',
  'phonePlaceholder': '電話番号',
  'getEmailOtp': 'ワンタイムパスワードをメールで入手する',
  'emailOTPSent': 'ワンタイムパスワードがメールで送信されました',
  'newRegisterCaptchaMsg': '間違ったメールIDを使用してログインを何度も試行しました。下の画像に表示されている文字を入力して本人確認を行ってください',
  'newRegisterCaptchaMsg2': 'さらにサポートが必要な場合は、お問い合わせください',
  'typeTheText': 'テキストを入力',
  'Please_Select_Country': 'あなたの国を選択してください',
  'Please_Enter_Phone': '電話番号を入力してください',
  'Please_Enter_PhoneCode': 'あなたの国番号を入力してください',
  'Form_incomplete': 'すべての欄に入力してください',
  'Incorrect_Password': '無効なパスワード',
  'trade_Deposit_funds': '入金',
  'deposit_funds_start_trading': '資金を入金して取引を開始する',
  'deposit_fund_easy': '資金の入金は簡単かつ迅速で、追加料金はかかりません。100ドルから始められます.',
  'deposit_funds_now': '今すぐ資金を入金する',
  'note_portal': '注: リダイレクトされます',
  'otpExpired': 'ワンタイムパスワードの有効期限が切れました。 もう一度ワンタイムパスワードをリクエストしてください',
  'emailValidationErrorMessage': '有効なメールアドレスを入力してください',
  'emailAlreadyExists': 'このメールは既に存在します',
  'invalidPhoneNumber': '携帯電話番号が無効です.',
  'wrongOTP': '誤ったワンタイムパスワード',
  'invalidCaptcha': '無効なキャプチャ',
  'otpSentOnYourEmail': 'ワンタイムパスワードがメールで送信されました',
  'alreadyExists': '記録は既に存在します',
  'registrationFailed': '登録に失敗しました。もう一度試してください.',
  'operationFailed': '何らかのエラーが発生しました。 もう一度試してください.',
  'spreadRewards':'情報を広めて報酬を獲得しましょう',
  'referralText':'誰かがあなたの紹介リンクで登録すると、あなたはその人の取引量に応じてコミッションを得ることができます.',
  'shareLink':'紹介リンクを共有する',
  'copy':'コピー',
  'scanRQCode':'このQRコードをスキャンして紹介リンクを確認してください',
  'invalidPromoCode': 'アルファベットや特殊文字を含めることはできません',
  'manage-account': 'アカウントを管理する',
  'referral': '紹介',
  'time-frame': '時間枠',
  'percentage': 'パーセンテージ',
  'predict':'取引開始',
  'languageName': '日本語',
  "AZ": "A-Z",
  "passwordLengthValidation": "8-31 文字",
  "az": "a-z",
  "passwordNumberValidation": "数字",
  'noSpecialCharacterLabel': "特殊文字は使用できません",
  'enter-otp': 'メールのワンタイムパスワードを入力してください',
  'signIn': 'サインイン',
  'home': 'ホーム',
  'loginHeading':'おかえりなさい!ログインして取引を開始してください',
  'already_using_crypto_countdown': 'すでにクリプトカウントダウンを使用していますか?',
  'getStarted': 'スタートする',
  'bannerHeadTitle': '価格傾向を予測し、最大80%の収益を獲得します',
  'bannerContent': 'クリプトカウントダウンは、暗号通貨の価格方向を正確に予測すると報酬が得られるWeb取引プラットフォームです。上または下をクリックするだけで簡単です.',
  // 'bannersubContent': '上または下をクリックするだけで簡単です.',
  'subscribeText': 'アカウントを作成する。所要時間はわずか30秒です.',
  'topValue': '$ 950000+',
  'topTraderText': '先月に支払われました。取引を開始して大きな利益を持ち帰りましょう',
  'topTraderHead' : ' トップトレーダー',
  'whaleAssuredTitle' : 'Whale Assured',
  'whaleRiskFree' : '100%安全な入金、リアルタイムの利益、簡単な出金',
  'convenientPayments' : '複数の支払い方法',
  'professionalWorldClassHead': 'あなたに勝利をもたらす世界クラスの取引プラットフォーム',
  'onBodingText' : 'クリプトカウントダウンを使用すると、投資からとても魅力的な収益を簡単に得ることができます。シンプル、正確、そして非常に安全です。早い出金とワンクリック取引により、金を獲得する最善の方法です.',
  'tradeUtmostHead': '最大限の自信を持って取引ができる',
  'tradeFirstHead':'両方の利点を最大限に活用',
  'tradeFirstText':'Whaleの伝統的な金融における深く根付いた経験と、現代のフィンテックの環境における先駆的なイノベーションにより、両方の長所を活用することができます',
  'tradeFirstHead2':'取引の基礎を深く掘り下げる',
  'tradeFirstText2':'登録時に無料の取引ガイドを入手して、クリプトカウントダウンの基本を理解してください.',
  'hello_there': 'こんにちは! あなた自身についてもう少し詳しく教えてください',
  'account_details': '口座の詳細',
  'contact_details': 'Contact 連絡先の詳細',
  'security_details': 'セキュリティの詳細',
  'new_to_crypto_countdown' : 'クリプトカウントダウン 初心者',
  'jing-sheng': 'Jing Sheng',
  'jing-sheng-textimonial': '取引に最適なアプリケーションです。私は取引所で長年取引しており、さまざまな情報源を利用しています。アプリケーションには、役立つ情報がたくさんあります。最も重要なのは、統計を追跡できることです.',
  'read-more-reviews': 'レビューをもっと読む',
  'copyright-text-content': 'このウェブサイトのいかなる部分も、明示的な許可なしに複製することはできません.',
  'copyright-text': ' Copyright © 2019 Whale Inc. All rights reserved.',
  'copyright-text-2': 'このウェブサイトのいかなる部分も、明示的な許可なしに複製することはできません.',
  'stay-assured': '安心してください。良い仲間になるでしょう!',
  'Create_Password': 'パスワードを作成してください',
  'xuxin': 'Xu Xin',
  'xuxin-textimonial': 'ブローカーにとって何が重要なのかはわかりませんが、私にとって最も重要なことは信頼と誠実さです。私は2016年12月からWhale-inc.comと協力しています。当初、私の戦略はあまり機能していませんでしたが、最近では一貫して大幅な利益を得ることができました.',
  'houan': 'Hou An',
  'houan-textimonial': '1月11日に257.49ドルでスタートしました。2月12日に823.96ドルの利益を出金しました。私は夜間に取引を行います。日中は取引しません。そしてそれは毎晩ではありません。価格の変更が小数点以下6桁まで計算されるので、より多くの取引で優位に立つことができるのが気に入っています.',
  'usp-heading': 'クリプトカウントダウンは成功への簡単なルートです',
  'usp-1-title': 'クイック出金',
  'usp-1-des': 'さまざまな方法で資金を素早く出金します。手数料はありません.',
  'usp-2-title': '柔軟な有効期限',
  'usp-2-des': 'わずか60秒から1時間までの7つの時間間隔から選択できます.',
  'usp-3-title': '外出先でも取引できます',
  'usp-3-des': 'アプリでいつでもどこでも取引',
  'usp-4-title': 'ハイリターン',
  'usp-4-des': '低い最低投資額で最大80%の収益を獲得',
  'usp-5-title': '暗号通貨に合わせてカスタマイズ',
  'usp-5-des': '仮想通貨に特化した唯一のcountdown trader',
  'usp-6-title': '紹介して獲得',
  'usp-6-des': '業界最高の紹介報酬プラン。友達を紹介して、取引していないときでもコミッションを獲得しましょう',
  'usp-7-title': '例に従う',
  'usp-7-des': '一流の戦略マネージャーをフォローしてください。いくつかのボタンを押すだけで利益への道が簡単になります.',
  'usp-8-title': 'カウントダウンペアの幅広い選択肢',
  'usp-8-des': '数回クリックするだけでさまざまな暗号通貨への投資を選択できます',
  'support-heading': 'とても簡単に大きな利益を得る最善の策.',
  'support-1-title': '魅力的な利益分配',
  'support-1-des': '独自のトークン システムを通じて取引利益を共有する業界唯一の取引所の一員になります',
  'support-2-title': 'ライブチャットサポート',
  'support-2-des': '取引中問題はありますか？ライブチャットで即時サポートを受ける',
  'support-3-title': '無料取引ガイド',
  'support-3-des': '私たちがあなたをご案内します。登録すると、無料の知識豊富な取引ガイドが提供されます',
  'talking-about': '他に誰が私たちのことを話しているのですか?',
  'disclaimer': '免責事項',
  'disclaimer-des': 'このサイトが提供する操作には高レベルのリスクが伴う可能性があり、その実行は非常に不安定な市場で行われます。 ウェブサイトおよびサービスが提供する金融商品を購入する場合、多額の投資損失が発生したり、アカウント上の資金がすべて失われる可能性があります。 市場への資金投資を決定する前に、十分な注意を払い、賢明な洞察力を働かせてください.',
   'shanghai': '上海',
   'money-fair': 'マネーフェア',
   'awards': '受賞歴',
   'trader': 'トレーダー',
   'choice': '選択',
  'demoAccountCannotProceed':'リアルアカウントに切り替えて続行してください',
   'traningAccount':'取引口座',
   'traningAccountContent':'トレーニングアカウントを使用すると、仮想のお金を使用して取引できます。資金は100,000米ドルです。トレーニングアカウントから資金を引き出すことはできません.',
   'realAccount':'あなたのMT4口座',
   'addMoney': 'お金を追加する',
   'tryNow': '今すぐ試す',
   'selectText': '選択',
   'selectedText': '選択済み',
   'in-usd': 'USD',
   'brand-name': 'myWhale',
   'fullName': 'フルネーム',
   'Please_Enter_Name': 'フルネームを入力してください',
   'nameValidationErrorMessage': '有効なフルネームを入力してください。数字や特殊文字を含めることはできません',
  'Login_Please_Enter_Account_and_Password':'アカウントとパスワードを入力してください',
  'Please_Enter_Account': 'アカウントを入力してください',
  'Validation_WrongAccountPwd':'無効なアカウントまたはパスワード',
  'Validation_Failed_SSO':'Authentication Failed, please login with your password',
  'Logout_Success_Message': '正常にログアウトされました',
  'Logout_Fail_Message': 'ログアウトできません',
  'Trade_History_Relogin_Message': 'ログイン履歴を取得できません。再度ログインしてください',
  "marketWatch": "マーケットウォッチ",

};
